import {
    Accordion,
    AccordionSummary,
    Typography,
    AccordionDetails,
    Grid,
    Autocomplete,
    TextField,
    RadioGroup,
    FormControlLabel,
    Radio,
    Button,
    FormLabel
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { gridSpacing } from 'store/constant';
import StartTime from 'views/variables/starttime';
import SubCard from './cards/SubCard';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionResponse } from 'types/overrides/chart';
import getDevicesAsync from 'service/device-service';
import getVariablesAsync from 'service/variable-service';
import { getTimestamps } from 'service/bdr-service';
const DeviceAccordion = (props: any) => {
    const [leftAxisTitle, setLeftAxisTitle] = useState('Left Axis Variables');
    const [expanded, setExpanded] = useState(true);
    const [selectedLeftVariables, setSelectedLeftVariables] = useState<string[]>([]);
    const [selectedRightVariables, setSelectedRightVariables] = useState<string[]>([]);
    const [rightVariables, setRightVariables] = useState<string[]>([]);
    const [selectedLeftAxisName, setSelectedLeftAxisName] = useState<string>('');
    const [selectedRightAxisName, setSelectedRightAxisName] = useState<string>('');

    const [vars, setVars] = useState<string[]>([]);
    const [devices, setDevices] = useState<any[]>([]);
    const [customers, setCustomers] = useState<any[]>([]);
    const [projects, setProjects] = useState<any[]>([]);
    const [vehicles, setVehicles] = useState<any[]>([]);
    const [timestamps, setTimestamps] = useState<any[]>([]);

    const [selectedSN, setSelectedSN] = useState<string[]>([]);
    const [selectedCustomers, setSelectedCustomers] = useState<string[]>([]);
    const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
    const [selectedHistogramsTableName, setSelectedHistogramsTableName] = useState<string>('');
    const [selectedSCUs, setselectedSCUs] = useState<string[]>([]);
    const [selectedVTBs, setselectedVTBs] = useState<string[]>([]);
    const [selectedTimestamp, setselectedTimestamp] = useState<any>('');
    const [selectedVehicles, setSelectedVehicles] = useState<string[]>([]);
    // const [selectedStartTime, setSelectedStartTime] = useState<Date | undefined>(undefined);
    // const [selectedEndTime, setSelectedEndTime] = useState<Date | undefined>(undefined);
    const [selectedSCU, setselectedSCU] = useState<string>('');

    const [lastClickedVTBIndex, setLastClickedVTBIndex] = useState<number | undefined>(undefined);
    const [lastClickedSCUIndex, setLastClickedSCUIndex] = useState<number | undefined>(undefined);

    const [selectedStartTime, setSelectedStartTime] = useState<Date | undefined>(
        props.UIType != 'BDR' && props.UIType != 'Test' ? new Date(new Date().setHours(new Date().getHours() - 2)) : undefined
    );
    const [selectedEndTime, setSelectedEndTime] = useState<Date | undefined>(
        props.UIType != 'BDR' && props.UIType != 'Test' ? new Date() : undefined
    );

    const [is3DHistogram, setIs3DHistogram] = useState<boolean>(false);

    const histograms2DTableNames = [
        'CellIDMaxCellVoltByColumn_Histogram',
        //'CellIDMaxCellVoltByRow_Histogram',
        'CellIDMinCellVoltByColumn_Histogram',
        //'CellIDMinCellVoltByRow_Histogram',
        'ChargingTime_Histogram',
        'CurrentAndAvgModuleTemp_Histogram',
        'CurrentVoltageNegative_Histogram',
        'CurrentVoltagePositive_Histogram',
        'DeltaCellVolt_Histogram',
        'DeltaSensorTemp_Histogram',
        'DeltaStringAndLinkVoltage_Histogram',
        'DOCAvgCurrent_Histogram',
        'DODAvgCurrent_Histogram',
        'MaxVoltTempCurr_Histogram',
        'ModuleIDMaxSensorTemp_Histogram',
        'PeakCurrent_Histogram',
        'PowerModeTransitions_Histogram',
        'SingleSCUElementsByColumns',
        //'SingleSCUElementsByRows',
        'SleepTime_Histogram',
        'StringSOC_Histogram',
        'StringSOCOCV_Histogram',
        'TimeSpanCoulombCounting_Histogram'
    ];
    const scus = ['101', '102', '103', '104', '105', '106', '107', '108', '109', '110', '111', '112'];

    const histograms3DTableNames = [
        'AvgSensorTemp_Histogram',
        'MaxCellVolt_Histogram',
        'MinCellVolt_Histogram',
        'SingleVTBElementsByColumns'
        //'ModuleIDMaxSensorTemp_Histogram'
        //'SingleVTBElementsByRows'
    ];

    const histogramsThatRequireSCUSelection = [
        'SingleSCUElementsByColumns',
        'DeltaSensorTemp_Histogram',
        'TimeSpanCoulombCounting_Histogram',
        'PowerModeTransitions_Histogram',
        'DeltaStringAndLinkVoltage_Histogram',
        'MaxCellVolt_Histogram',
        'MinCellVolt_Histogram',
        'CurrentAndAvgModuleTemp_Histogram',
        'AvgSensorTemp_Histogram',
        'ModuleIDMaxSensorTemp_Histogram',
        'DOCAvgCurrent_Histogram',
        'DODAvgCurrent_Histogram',
        'MaxVoltTempCurr_Histogram',
        'CurrentVoltagePositive_Histogram',
        'CurrentVoltageNegative_Histogram',
        'CellIDMaxCellVoltByColumn_Histogram',
        'CellIDMinCellVoltByColumn_Histogram'
    ];

    const vtbs = Array.from({ length: 30 }, (_, i) => (i + 1).toString());

    let histogramsTableNames = histograms2DTableNames.concat(histograms3DTableNames);
    histogramsTableNames.sort();

    if (props.UIType === 'Test') {
        histogramsTableNames = [
            'AvgSensorTemp_Histogram',
            'CellIDMaxCellVoltByColumn_Histogram',
            'CellIDMinCellVoltByColumn_Histogram',
            'ChargingTime_Histogram',
            'CurrentAndAvgModuleTemp_Histogram',
            'CurrentVoltageNegative_Histogram',
            'CurrentVoltagePositive_Histogram',
            'DeltaCellVolt_Histogram',
            'DeltaSensorTemp_Histogram',
            'DeltaStringAndLinkVoltage_Histogram',
            'DOCAvgCurrent_Histogram',
            'DODAvgCurrent_Histogram',
            'MaxVoltTempCurr_Histogram',
            'MaxCellVolt_Histogram',
            'MinCellVolt_Histogram',
            'ModuleIDMaxSensorTemp_Histogram',
            'PeakCurrent_Histogram',
            'PowerModeTransitions_Histogram',
            'SingleSCUElementsByColumns',
            'SingleVTBElementsByColumns',
            'SleepTime_Histogram',
            'StringSOC_Histogram',
            'StringSOCOCV_Histogram',
            'TimeSpanCoulombCounting_Histogram'
        ];
    }

    useEffect(() => {
        const fetchDropDowns = async () => {
            try {
                const devicesResponse = await getDevicesAsync();
                setDevices(devicesResponse);
                const v = await getVariablesAsync();
                setVars(v);

                const customersResponse: Set<string> = new Set();
                devicesResponse.forEach((device: any) => {
                    // console.log(device.Customer, ' - ', device['Project Number'], ' - ', device['Vehicle ID']);
                    if (device.Customer !== null) {
                        customersResponse.add(device.Customer);
                    }
                });
                setCustomers(Array.from(customersResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };
        fetchDropDowns();
    }, []);

    useEffect(() => {
        props.UIType == 'LOGS_CHART' ? setLeftAxisTitle('Left Axis Variables') : setLeftAxisTitle('Variables');
    }, [props.UIType]);

    const handleLeftVarChange = (_event: any, value: string[]) => {
        setSelectedLeftVariables(value);
    };
    const handleRightVarChange = (_event: any, value: string[]) => {
        setSelectedRightVariables(value);
    };

    const handleCustomerChange = (_event: any, value: string[]) => {
        setSelectedCustomers(value);
        const projectsResponse: Set<string> = new Set();
        devices.forEach((device: any) => {
            if (value.includes(device.Customer) && device['Project Number'] !== null) {
                projectsResponse.add(device['Project Number']);
            }
        });
        setProjects(Array.from(projectsResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
    };
    const handleProjectChange = (_event: any, value: string[]) => {
        setSelectedProjects(value);
        const vehiclesResponse: Set<string> = new Set();
        devices.forEach((device: any) => {
            if (selectedCustomers.includes(device.Customer) && value.includes(device['Project Number']) && device['Vehicle ID'] !== null) {
                vehiclesResponse.add(device['Vehicle ID']);
            }
        });
        setVehicles(Array.from(vehiclesResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
    };
    const handleVehicleChange = (_event: any, value: string[]) => {
        setSelectedVehicles(value);
        let serialNumbersResponse: Set<string> = new Set();
        devices.forEach((device: any) => {
            if (
                selectedCustomers.includes(device.Customer) &&
                selectedProjects.includes(device['Project Number']) &&
                value.includes(device['Vehicle ID'])
            ) {
                serialNumbersResponse.add(device['Device ID']);
            }
        });
        setSelectedSN(Array.from(serialNumbersResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
    };

    const handleStartTimeChange = (value: any) => {
        setSelectedStartTime(value);
    };

    const handleEndTimeChange = (value: Date) => {
        setSelectedEndTime(value);
    };

    const handleAccordianChange = (event: any) => {
        setExpanded(!expanded);
    };

    const handleLeftAxisNameChange = (event: any) => {
        setSelectedLeftAxisName(event.target.value);
    };
    const handleRightAxisNameChange = (event: any) => {
        setSelectedRightAxisName(event.target.value);
    };

    const handle_BDR_HistogramsTableNameChanged = (_event: any, value: any) => {
        setSelectedHistogramsTableName(value);
        setIs3DHistogram(histograms3DTableNames.includes(value));
    };

    const handle_BDR_SCUChanged = (event: any, value: any) => {
        // New VTB Selected, not removed
        if (value.length > selectedSCUs.length) {
            const selectedValue = value[value.length - 1];
            const index = scus.indexOf(selectedValue);

            if (event.shiftKey && lastClickedSCUIndex !== undefined) {
                const start = Math.min(lastClickedSCUIndex, index);
                const end = Math.max(lastClickedSCUIndex, index);
                const newSelection = scus.slice(start, end + 1);

                setselectedSCUs((prev) => Array.from(new Set([...prev, ...newSelection])));
            } else {
                setselectedSCUs((prev) => {
                    if (prev.includes(selectedValue)) {
                        return prev.filter((item) => item !== selectedValue);
                    } else {
                        return [...prev, selectedValue];
                    }
                });
                setLastClickedSCUIndex(index);
            }
        } else {
            setselectedSCUs(value);
            setLastClickedSCUIndex(undefined);
        }
    };

    const handle_BDR_SCUSingleChange = (_event: any, value: any) => {
        setselectedSCU(value);
    };

    const handle_BDR_VTBChanged = (event: any, value: any) => {
        // New VTB Selected, not removed
        if (value.length > selectedVTBs.length) {
            const selectedValue = value[value.length - 1];
            const index = vtbs.indexOf(selectedValue);

            if (event.shiftKey && lastClickedVTBIndex !== undefined) {
                const start = Math.min(lastClickedVTBIndex, index);
                const end = Math.max(lastClickedVTBIndex, index);
                const newSelection = vtbs.slice(start, end + 1);

                setselectedVTBs((prev) => Array.from(new Set([...prev, ...newSelection])));
            } else {
                setselectedVTBs((prev) => {
                    if (prev.includes(selectedValue)) {
                        return prev.filter((item) => item !== selectedValue);
                    } else {
                        return [...prev, selectedValue];
                    }
                });
                setLastClickedVTBIndex(index);
            }
        } else {
            setselectedVTBs(value);
            setLastClickedVTBIndex(undefined);
        }
    };

    const handleTimeChange = (event: any, value: any) => {
        setselectedTimestamp(value);
    };

    const getBdrTimestamps = async () => {
        console.log('getBdrTimestamps', props.UIType, selectedHistogramsTableName);
        if (props.UIType === 'BDR' && selectedHistogramsTableName !== '' && selectedHistogramsTableName !== null) {
            const startTime: string =
                selectedStartTime !== undefined
                    ? new Date(
                          Date.UTC(
                              selectedStartTime.getUTCFullYear(),
                              selectedStartTime.getUTCMonth(),
                              selectedStartTime.getUTCDate(),
                              0,
                              0,
                              0,
                              0
                          )
                      )
                          ?.toISOString()
                          .replace('T', ' ')
                          .slice(0, 23)
                    : '';
            const endTime: string =
                selectedEndTime !== undefined
                    ? new Date(
                          Date.UTC(
                              selectedEndTime.getUTCFullYear(),
                              selectedEndTime.getUTCMonth(),
                              selectedEndTime.getUTCDate(),
                              23,
                              59,
                              59,
                              999
                          )
                      )
                          ?.toISOString()
                          .replace('T', ' ')
                          .slice(0, 23)
                    : '';

            const scusSelected = [];
            if (histogramsThatRequireSCUSelection.includes(selectedHistogramsTableName)) {
                scusSelected.push(selectedSCU);
            } else {
                scusSelected.push(...selectedSCUs);
            }

            const requestBody: AccordionResponse = {
                SNs: selectedSN,
                startTimeStamp: startTime,
                endTimeStamp: endTime,
                variables: [...selectedLeftVariables, ...selectedRightVariables],
                chart: props.UIType == 'LOGS_CHART',
                leftAxisName: selectedLeftAxisName,
                rightAxisName: selectedRightAxisName,
                leftAxisVariables: selectedLeftVariables,
                rightAxisVariables: selectedRightVariables,
                // axisNames: [{ left: selectedLeftAxisName, right: selectedRightAxisName }]
                BDR_histogramTableName: selectedHistogramsTableName,
                BDR_SCUs: selectedSCUs,
                BDR_VTBs: selectedVTBs,
                vehicles: selectedVehicles
            };
            //const SN = Array.isArray(requestBody.SNs) ? requestBody.SNs[0] : requestBody.SNs;

            const SN = requestBody.SNs;
            const response = await getTimestamps(
                requestBody.BDR_histogramTableName,
                SN,
                requestBody.BDR_VTBs,
                requestBody.BDR_SCUs,
                requestBody.startTimeStamp,
                requestBody.endTimeStamp
            );
            const formattedTimes = response.map((time: any) => {
                const date = new Date(time.TimeStampUTC);

                // Manually format the date components
                const year = date.getUTCFullYear();
                const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                const day = String(date.getUTCDate()).padStart(2, '0');
                const hours = String(date.getUTCHours()).padStart(2, '0');
                const minutes = String(date.getUTCMinutes()).padStart(2, '0');
                const seconds = String(date.getUTCSeconds()).padStart(2, '0');

                const formattedTime = `${year}/${month}/${day} ${hours}:${minutes}:${seconds} UTC`;

                return {
                    originalTime: time.TimeStampUTC,
                    displayTime: formattedTime
                };
            });
            setTimestamps(formattedTimes);
        }
    };

    useEffect(() => {
        getBdrTimestamps();
    }, [selectedHistogramsTableName, selectedSCUs, selectedVTBs, selectedStartTime, selectedEndTime]);

    const handleSubmit = async (e: any) => {
        setExpanded(false);
        setRightVariables(selectedRightVariables);
        e.preventDefault();

        let startTime: string =
            selectedStartTime !== undefined
                ? new Date(
                      Date.UTC(
                          selectedStartTime.getUTCFullYear(),
                          selectedStartTime.getUTCMonth(),
                          selectedStartTime.getUTCDate(),
                          0,
                          0,
                          0,
                          0
                      )
                  )
                      ?.toISOString()
                      .replace('T', ' ')
                      .slice(0, 23)
                : '';
        let endTime: string =
            selectedEndTime !== undefined
                ? new Date(
                      Date.UTC(
                          selectedEndTime.getUTCFullYear(),
                          selectedEndTime.getUTCMonth(),
                          selectedEndTime.getUTCDate(),
                          23,
                          59,
                          59,
                          999
                      )
                  )
                      ?.toISOString()
                      .replace('T', ' ')
                      .slice(0, 23)
                : '';

        if (
            props.UIType === 'BDR' &&
            selectedTimestamp?.originalTime !== '' &&
            selectedTimestamp?.originalTime !== null &&
            selectedTimestamp?.originalTime !== undefined
        ) {
            startTime = new Date(selectedTimestamp?.originalTime)?.toISOString().replace('T', ' ').slice(0, 23);
            endTime = new Date(selectedTimestamp?.originalTime)?.toISOString().replace('T', ' ').slice(0, 23);
        }

        const scusSelected = [];
        if (histogramsThatRequireSCUSelection.includes(selectedHistogramsTableName)) {
            scusSelected.push(selectedSCU);
        } else {
            scusSelected.push(...selectedSCUs);
        }

        const requestBody: AccordionResponse = {
            SNs: selectedSN,
            startTimeStamp: startTime,
            endTimeStamp: endTime,
            variables: [...selectedLeftVariables, ...selectedRightVariables],
            chart: props.UIType == 'LOGS_CHART',
            leftAxisName: selectedLeftAxisName,
            rightAxisName: selectedRightAxisName,
            leftAxisVariables: selectedLeftVariables,
            rightAxisVariables: selectedRightVariables,
            // axisNames: [{ left: selectedLeftAxisName, right: selectedRightAxisName }]
            BDR_histogramTableName: selectedHistogramsTableName,
            BDR_SCUs: scusSelected,
            BDR_VTBs: selectedVTBs,
            vehicles: selectedVehicles
        };
        props.parentCallback(requestBody);
    };

    return (
        <Accordion key={'accordion'} expanded={expanded} onChange={handleAccordianChange}>
            <AccordionSummary key={'accordionSummary'} expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                {!expanded ? (
                    selectedCustomers.length > 0 ? (
                        selectedCustomers.map((customer, index) => {
                            return (
                                <Typography key={'accordionSummaryClosed'}>
                                    Customer: {customer}&emsp;&emsp;|&emsp;&emsp;Project Number: {selectedProjects[index]}
                                    &emsp;&emsp;|&emsp;&emsp;Vehicle ID: {selectedVehicles[index]}
                                    {props.UIType === 'BDR' && selectedTimestamp && (
                                        <>&emsp;&emsp;|&emsp;&emsp;Timestamp: {selectedTimestamp?.displayTime}</>
                                    )}
                                    {(props.UIType == 'DTC' || props.UIType == 'LOGS' || props.UIType == 'LOGS_CHART') &&
                                    selectedStartTime &&
                                    selectedEndTime ? (
                                        <>
                                            &emsp;&emsp;|&emsp;&emsp;Start Time: {selectedStartTime.getMonth() + 1}/
                                            {selectedStartTime.getDate()}/{selectedStartTime.getFullYear()} {selectedStartTime?.getHours()}:
                                            {selectedStartTime.getMinutes() === 0 ? '00' : selectedStartTime.getMinutes()}
                                            &emsp;&emsp;|&emsp;&emsp;End Time: {selectedEndTime.getMonth() + 1}/{selectedEndTime.getDate()}/
                                            {selectedEndTime.getFullYear()} {selectedEndTime.getHours()}:
                                            {selectedEndTime.getMinutes() === 0 ? '00' : selectedEndTime?.getMinutes()}
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </Typography>
                            );
                        })
                    ) : (
                        <Typography key={'accordionSummaryOpen'}>Choose properties to view in a chart or table</Typography>
                    )
                ) : (
                    <Typography key={'accordionInstructions'}>Choose properties to view in a chart or table</Typography>
                )}
            </AccordionSummary>
            <AccordionDetails key={'accordionDetails'}>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item lg={1.5}></Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <SubCard
                                title={
                                    <span>
                                        Customer <span style={{ color: 'red' }}>*</span>
                                    </span>
                                }
                            >
                                <Grid container direction="column" spacing={3}>
                                    <Grid item>
                                        <Autocomplete
                                            key={'selectedCustomers'}
                                            multiple
                                            limitTags={2}
                                            options={customers}
                                            getOptionLabel={(option: any) => option}
                                            value={selectedCustomers}
                                            onChange={handleCustomerChange}
                                            // defaultValue={}
                                            style={{ width: '100%' }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <SubCard
                                title={
                                    <span>
                                        Project Number <span style={{ color: 'red' }}>*</span>
                                    </span>
                                }
                            >
                                <Grid container direction="column" spacing={3}>
                                    <Grid item>
                                        <Autocomplete
                                            key={'selectedProjects'}
                                            multiple
                                            limitTags={2}
                                            options={projects}
                                            getOptionLabel={(option) => option}
                                            value={selectedProjects}
                                            onChange={handleProjectChange}
                                            // defaultValue={}
                                            style={{ width: '100%' }}
                                            //disabled={selectedCustomers.length === 0}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <SubCard
                                title={
                                    <span>
                                        Vehicle ID <span style={{ color: 'red' }}>*</span>
                                    </span>
                                }
                            >
                                <Grid container direction="column" spacing={3}>
                                    <Grid item>
                                        <Autocomplete
                                            key={'selectedVehicles'}
                                            multiple
                                            limitTags={2}
                                            options={vehicles}
                                            getOptionLabel={(option) => option}
                                            value={selectedVehicles}
                                            onChange={handleVehicleChange}
                                            // defaultValue={}
                                            style={{ width: '100%' }}
                                            //disabled={selectedCustomers.length === 0 || selectedProjects.length === 0}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                        <Grid item lg={1.5}></Grid>
                        <Grid item lg={1.5}></Grid>
                        {props.UIType == 'DTC' || props.UIType == 'LOGS' || props.UIType == 'LOGS_CHART' ? (
                            <>
                                <Grid item xs={12} md={6} lg={3}>
                                    <SubCard
                                        title={
                                            <span>
                                                {leftAxisTitle} <span style={{ color: 'red' }}>*</span>
                                            </span>
                                        }
                                    >
                                        <Grid container direction="column" spacing={3}>
                                            <Grid item>
                                                {props.UIType == 'LOGS_CHART' ? (
                                                    <TextField
                                                        key={'left_axis_key'}
                                                        id="left-axis-label"
                                                        label="Left Axis Label"
                                                        variant="outlined"
                                                        value={selectedLeftAxisName}
                                                        onChange={handleLeftAxisNameChange}
                                                        style={{ paddingBottom: '1rem', width: '15rem' }}
                                                    />
                                                ) : (
                                                    <></>
                                                )}
                                                <Autocomplete
                                                    key={'selectedLeftVariables'}
                                                    multiple
                                                    limitTags={2}
                                                    options={vars}
                                                    getOptionLabel={(option) => option}
                                                    value={selectedLeftVariables}
                                                    onChange={handleLeftVarChange}
                                                    style={{ width: '15rem' }}
                                                    // defaultValue={}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>
                                {props.UIType == 'LOGS_CHART' && (
                                    <Grid item xs={12} md={6} lg={3}>
                                        <SubCard title="Right Axis Variables (Optional)">
                                            <Grid container direction="column" spacing={3}>
                                                <Grid item>
                                                    <TextField
                                                        key="right_axis_key"
                                                        id="right-axis-label"
                                                        label="Right Axis Label"
                                                        variant="outlined"
                                                        value={selectedRightAxisName}
                                                        onChange={handleRightAxisNameChange}
                                                        style={{ paddingBottom: '1rem', width: '15rem' }}
                                                    />
                                                    <Autocomplete
                                                        key={'selectedRightVariables'}
                                                        multiple
                                                        limitTags={2}
                                                        options={vars}
                                                        getOptionLabel={(option) => option}
                                                        value={selectedRightVariables}
                                                        onChange={handleRightVarChange}
                                                        style={{ width: '15rem' }}
                                                        // defaultValue={}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    </Grid>
                                )}

                                <Grid item xs={12} md={6} lg={3} display={'flex'} flexDirection={'column'}>
                                    <SubCard
                                        title={
                                            <span>
                                                Date Filter <span style={{ color: 'red' }}>*</span>
                                            </span>
                                        }
                                    >
                                        <Grid container direction="column" spacing={3}>
                                            <Grid item>
                                                <StartTime
                                                    key={'startTime'}
                                                    timeLabel="Start Time"
                                                    value={selectedStartTime}
                                                    onChange={handleStartTimeChange}
                                                    time={selectedStartTime}
                                                    myMargin={undefined}
                                                ></StartTime>
                                                <StartTime
                                                    key={'endTime'}
                                                    timeLabel="End Time"
                                                    value={selectedEndTime}
                                                    onChange={handleEndTimeChange}
                                                    time={selectedEndTime}
                                                    myMargin={'normal'}
                                                ></StartTime>
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid item xs={12} md={6} lg={3}>
                                    <SubCard
                                        title={
                                            <span>
                                                Histogram <span style={{ color: 'red' }}>*</span>
                                            </span>
                                        }
                                    >
                                        <Grid container direction="column" spacing={3}>
                                            <Grid item>
                                                <Autocomplete
                                                    key={'selectedHistogramsTableNames'}
                                                    // multiple
                                                    limitTags={2}
                                                    options={histogramsTableNames}
                                                    getOptionLabel={(option) => option}
                                                    value={selectedHistogramsTableName}
                                                    onChange={handle_BDR_HistogramsTableNameChanged}
                                                    // defaultValue={}
                                                    style={{ width: '100%' }}
                                                    // disabled={selectedCustomers.length === 0}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>
                                {!histogramsThatRequireSCUSelection.includes(selectedHistogramsTableName) && (
                                    <Grid item xs={12} md={6} lg={3}>
                                        <SubCard title={<span>SCU</span>}>
                                            <Grid container direction="column" spacing={3}>
                                                <Grid item>
                                                    <Autocomplete
                                                        key={'selectedSCUs'}
                                                        multiple
                                                        disableCloseOnSelect
                                                        limitTags={2}
                                                        options={scus}
                                                        getOptionLabel={(option) => option}
                                                        value={selectedSCUs}
                                                        onChange={handle_BDR_SCUChanged}
                                                        // defaultValue={}
                                                        style={{ width: '100%' }}
                                                        disabled={selectedCustomers.length === 0}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    </Grid>
                                )}
                                {histogramsThatRequireSCUSelection.includes(selectedHistogramsTableName) && (
                                    <Grid item xs={12} md={6} lg={3}>
                                        <SubCard
                                            title={
                                                <span>
                                                    SCU
                                                    <span style={{ color: 'red' }}>* (Select only one SCU)</span>
                                                </span>
                                            }
                                        >
                                            <Grid container direction="column" spacing={3}>
                                                <Grid item>
                                                    <Autocomplete
                                                        key={'selectedSCUs'}
                                                        limitTags={2}
                                                        options={scus}
                                                        getOptionLabel={(option) => option}
                                                        value={selectedSCU}
                                                        onChange={handle_BDR_SCUSingleChange}
                                                        style={{ width: '15rem' }}
                                                        disabled={selectedCustomers.length === 0}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    </Grid>
                                )}
                                {is3DHistogram ? (
                                    <>
                                        {/* COMMENTED THIS CODE OUT FOR FORMAT PURPOSES */}
                                        {/* <Grid item lg={1.5}></Grid>
                                        <Grid item lg={1.5}></Grid> */}
                                        <Grid item xs={12} md={6} lg={3}>
                                            <SubCard title="VTB">
                                                <Grid container direction="column" spacing={3}>
                                                    <Grid item>
                                                        <Autocomplete
                                                            key={'selectedVTBs'}
                                                            multiple
                                                            disableCloseOnSelect
                                                            limitTags={2}
                                                            options={vtbs}
                                                            getOptionLabel={(option) => option}
                                                            value={selectedVTBs}
                                                            onChange={handle_BDR_VTBChanged}
                                                            // defaultValue={}
                                                            style={{ width: '100%' }}
                                                            // disabled={selectedCustomers.length === 0}
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </SubCard>
                                        </Grid>
                                        <Grid item lg={1.5}></Grid>
                                        <Grid item lg={1.5}></Grid>
                                    </>
                                ) : (
                                    <></>
                                )}
                                {props.UIType !== 'Test' && (
                                    <Grid item xs={12} md={6} lg={3} display={'flex'} flexDirection={'column'}>
                                        <SubCard title={<span>Date Filter </span>}>
                                            <Grid container display={'flex'} flexDirection={'row'} columnGap={'7px'} rowGap={'10px'}>
                                                <StartTime
                                                    key={'startTime'}
                                                    timeLabel="Start Date"
                                                    value={selectedStartTime}
                                                    onChange={handleStartTimeChange}
                                                    time={selectedStartTime}
                                                    myMargin={undefined}
                                                ></StartTime>
                                                <StartTime
                                                    key={'endTime'}
                                                    timeLabel="End Date"
                                                    value={selectedEndTime}
                                                    onChange={handleEndTimeChange}
                                                    time={selectedEndTime}
                                                    myMargin={undefined}
                                                ></StartTime>
                                                <Autocomplete
                                                    key={'timestamp'}
                                                    options={timestamps}
                                                    getOptionLabel={(option) => option?.displayTime}
                                                    inputValue={selectedTimestamp?.displayTime}
                                                    onChange={handleTimeChange}
                                                    isOptionEqualToValue={(option, value) => option?.originalTime === value?.originalTime}
                                                    // defaultValue={}
                                                    style={{ width: '100%' }}
                                                    renderInput={(params) => <TextField label="Available timestamps" {...params} />}
                                                />
                                            </Grid>
                                        </SubCard>
                                    </Grid>
                                )}
                            </>
                        )}
                        {is3DHistogram ? (
                            <Grid item xs={6} md={6} lg={1.5}>
                                <Grid item lg={1.5}></Grid>
                            </Grid>
                        ) : (
                            <Grid item xs={12} md={12} lg={6}>
                                <Grid item lg={1.5}></Grid>
                                <Grid item lg={3}></Grid>
                            </Grid>
                        )}
                        <Grid item lg={2} display={'flex'} alignItems={'center'} paddingTop={'24px'}>
                            <Button
                                key={'submitButton'}
                                variant="contained"
                                type="submit"
                                style={{ marginTop: '16px', marginBottom: '8px', height: '51.25px' }}
                                disabled={
                                    selectedCustomers.length === 0 ||
                                    selectedProjects.length === 0 ||
                                    selectedVehicles.length === 0 ||
                                    ((props.UIType == 'DTC' || props.UIType == 'LOGS' || props.UIType == 'LOGS_CHART') &&
                                        selectedLeftVariables.length === 0) ||
                                    (histogramsThatRequireSCUSelection.includes(selectedHistogramsTableName) &&
                                        (selectedSCU?.length === 0 || selectedSCU === null))
                                }
                            >
                                Create
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </AccordionDetails>
        </Accordion>
    );
};

export default DeviceAccordion;
